<template>
  <div v-if="this.isLoading === true">
    <base-spinner></base-spinner>
  </div>
  <div v-else class="table">
    <div class="table-header">
      <p>Media</p>

      <select class="w3-select w3-border" v-model="filterCategory">
        <option value="" disabled selected>Chọn danh mục</option>
        <option value="">Tất cả</option>
        <option v-for="mc in getMCSelectFilter" :key="mc.id" :value="mc.id">
          {{ mc.name }}
        </option>
      </select>

      <select class="w3-select w3-border" v-model="filterMedia">
        <option value="" disabled selected>Chọn loại</option>
        <option value="">Tất cả</option>
        <option value="img">Hình ảnh</option>
        <option value="vd">Video</option>
      </select>

      <div>
        <input v-model="filterTerm" placeholder="Tên" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="addClick" class="add-new" v-if="$checkPermission('create_media')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên</th>
            <th>Media</th>
            <th>Mô tả</th>
            <th>Link Media</th>
            <th>Danh mục</th>
            <th>Đuôi file</th>
            <th>Ẩn</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>
              <div class="overflow-td">
                {{ ctt.fileName }}
              </div>
            </td>
            <td v-if="ctt.fileExtension === '.mp4'">
              <video controls>
                  <source :src="imageSrc(ctt.filePath)" type="video/mp4">
                  Trình duyệt của bạn không hỗ trợ thẻ video.
              </video>
            </td>
            <td v-else><img :src="imageSrc(ctt.filePath)"></td>
            <td>
              <div class="overflow-td">
                {{ ctt.fileDescription }}
              </div>
            </td>
            <td>
              <div class="overflow-td">
                {{ ctt.filePath }}
              </div>
            </td>
            <td>{{ showMediaCategory(ctt.categoryId) }}</td>
            <td>{{ ctt.fileExtension }}</td>
            <td>{{ subForBoolean(ctt.isHidden) }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_media')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_media')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>

  </div>

  <!-- modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" size="large">
    <div class="site-box">
      <div class="first-site">
        <div class="data-display">
          <div class="box"> <p>Tên</p> </div>
          <input type="text" v-model="fileName"/>
        </div>

        <div class="data-display">
          <div class="box"> <p>Tên en</p> </div>
          <input type="text" v-model="enFileName"/>
        </div>

        <div class="data-display">
          <div class="box"> <p>Danh mục<span style="color: red;">*</span></p> </div>
          <select v-model="categoryId">
            <option disabled value="">Chọn danh mục</option>
            <option v-for="mc in getMCSelect" :key="mc.id" :value="mc.id">
              {{ mc.name }}
            </option>
          </select>
        </div>

        <div class="data-display">
          <div class="box"> <p>Direct Link</p> </div>
          <input type="text" v-model="link"/>
        </div>

        <div class="data-display">
          <div class="box"> <p>Mô tả</p> </div>
          <textarea v-model="fileDescription"></textarea>
        </div>

        <div class="data-display">
          <div class="cb-box"> <p>Ẩn<span style="color: red;">*</span></p> </div>
          <div>
            <label>
              <input id="cb" type="checkbox" :checked="isHidden === true" v-model="isHidden" :true-value="true" :false-value="null" />
              Có
            </label>

            <label>
              <input id="cb" type="checkbox" :checked="isHidden === false" v-model="isHidden" :true-value="false" :false-value="null" />
              Không
            </label>
          </div>
        </div>
      </div>
      <div class="second-site">
        <div>
          <div v-if="preview">
            <img v-if="media && fileExtension !== '.mp4'" :src="media" style="width: 230px; height: 205px; object-fit: scale-down; background: #efefef;" />
            <video v-if="media && fileExtension === '.mp4'" width="230" height="205" controls style="background: #efefef;">
                <source :src="media"  type="video/mp4">
                Trình duyệt của bạn không hỗ trợ thẻ video.
            </video>
          </div>
          <div v-else>
            <img v-if="media && fileExtension !== '.mp4'" :src="imageSrc(media)" style="width: 230px; height: 205px; object-fit: scale-down; background: #efefef;" />
            <video v-if="media && fileExtension === '.mp4'" width="230" height="205" controls ref="modalVideo" style="background: #efefef;">
                <source :src="imageSrc(media)"  type="video/mp4">
                Trình duyệt của bạn không hỗ trợ thẻ video.
            </video>
          </div>
          <input type="file" @change="previewImage" ref="fileInput" style="margin: 10px 0px;">
        </div>
      </div>
    </div>

    <div class="btn-container">
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id === 0" @click="createClick()">
        <p class="btn-text">Tạo</p>
      </button>
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id !== 0" @click="updateClick()">
        <p class="btn-text">Cập nhật</p>
      </button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)">
  </alert-modal>
</template>

<script>
export default {
  data () {
    return {
      fileUpload: '',
      preview: false,
      pageSize: 6,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      appliedTerm: '',
      filterCategory: '',
      filterMedia: '',
      selectedId: 0,
      isLoading: false,
      requestLoading: false,
      // data
      id: 0,
      media: '',
      fileName: '',
      enFileName: '',
      fileDescription: '',
      categoryId: 0,
      lang: 'vn',
      fileExtension: '',
      createdAt: '',
      author: '',
      updatedAt: '',
      link: '',
      isHidden: false,
      propertiesToCheck: ['categoryId', 'fileUpload'],
      cacheBuster: Date.now()
    }
  },
  computed: {
    getMedia () {
      return this.$store.getters['media/backendMediaWithoutPage']
      // return this.$store.getters['media/backendMedia']
    },
    filterItems () {
      if (!this.appliedTerm && !this.filterCategory && !this.filterMedia) {
        return this.getMedia
      }
      this.reloadPageWithFilter()
      const searchTerm = this.appliedTerm.toLowerCase()
      const searchNumber = Number(this.filterCategory)

      // eslint-disable-next-line
      let data = this.getMedia.filter(data => data.categoryId.toString() === searchNumber.toString())

      // Chi search ten
      if (data.length === 0 && !this.filterCategory && !this.filterMedia) {
        return this.getMedia.filter(data => data.fileName.toLowerCase().includes(searchTerm))
      } else if (data.length === 0 && !this.filterCategory && this.filterMedia) {
        data = this.getMedia
      }

      if (this.filterMedia === 'vd') {
        data = data.filter(data => data.fileExtension === '.mp4')
      } else if (this.filterMedia === 'img') {
        data = data.filter(data => data.fileExtension !== '.mp4')
      }

      return data.filter(data => data.fileName.toLowerCase().includes(searchTerm))
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItems.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItems.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    },
    getMCSelect () {
      return this.$store.getters['media/selectMediaCategory']
    },
    getMCSelectFilter () {
      return this.$store.getters['media/selectMediaCategoryFilterWithoutPage']
    }
  },
  // watch: {
  //   categoryId (newId) {
  //     if (newId === 2014) {
  //       this.link = '/devices-utilities/training-devices/'
  //     } else if (newId === 2015) {
  //       this.link = '/devices-utilities/classroom/'
  //     } else {
  //       this.link = ''
  //     }
  //   }
  // },
  methods: {
    sendFilterTerm () {
      this.appliedTerm = this.filterTerm
    },
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    },
    subForBoolean (value) {
      if (value) return 'Có'
      else return 'Không'
    },
    showMediaCategory (id) {
      return this.$store.getters['media/showMediaCategory'](id)
    },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    previewImage (event) {
      this.fileUpload = event.target.files[0]
      this.preview = true
      if (this.fileUpload) {
        // this.media = URL.createObjectURL(this.fileUpload)
        this.fileExtension = '.' + this.fileUpload.name.split('.').pop().toLowerCase()
        this.media = null
        setTimeout(() => {
          this.media = URL.createObjectURL(this.fileUpload)
        }, 100)
      }
    },
    getCurrentDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    toggleModal () {
      this.modalActive = !this.modalActive
      const video = this.$refs.modalVideo
      if (video) {
        video.load() // Reload the video to reset it completely
      }
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getMediaData () {
      this.isLoading = true
      await this.$store.dispatch('media/getMediaCategoriesData')
      await this.$store.dispatch('media/getMediaAdminData')
      this.isLoading = false
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (this[key] === '') {
          this.isValid = false
        }
      })
    },
    addClick () {
      this.isValid = true
      this.modalTitle = 'Add Media'
      this.$refs.fileInput.value = null
      this.id = 0
      this.media = ''
      this.fileName = ''
      this.fileDescription = ''
      this.categoryId = ''
      this.lang = 'vn'
      this.createdAt = ''
      this.updatedAt = ''
      this.link = ''
      this.enfileName = null
      this.fileUpload = ''
      this.isHidden = false
      this.toggleModal()
    },
    async createClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError('Hãy chọn ảnh và điền đủ thông tin cần thiết để tiếp tục')
        return
      }

      // if (this.categoryId === 2014) {
      //   this.link = '/devices-utilities/training-devices/' + this.link
      // } else if (this.categoryId === 2015) {
      //   this.link = '/devices-utilities/classroom/' + this.link
      // }

      const newMedia = {
        file: this.fileUpload,
        fileName: this.fileName,
        categoryId: this.categoryId,
        fileDescription: this.fileDescription,
        createdAt: this.getCurrentDate(),
        updatedAt: this.updatedAt,
        lang: 'all',
        isHidden: this.isHidden,
        link: this.link,
        enFileName: this.enfileName
      }

      try {
        await this.$store.dispatch('media/postMedia', newMedia)
        this.requestLoading = false
        this.$showSuccess('Tạo thành công')
        this.getMediaData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    editClick (data) {
      this.isValid = true
      this.preview = false
      this.toggleModal()
      this.modalTitle = 'Edit Media'
      this.fileUpload = ''
      this.$refs.fileInput.value = null
      this.id = data.id
      this.media = data.filePath
      this.fileName = data.fileName
      this.fileDescription = data.fileDescription
      this.categoryId = data.categoryId
      this.lang = data.lang
      this.createdAt = data.createdAt
      this.updatedAt = data.updatedAt
      this.fileExtension = data.fileExtension
      this.isHidden = data.isHidden
      this.link = data.link
      this.enFileName = data.enFileName
    },
    async updateClick () {
      this.requestLoading = true
      if (this.isHidden === null) {
        this.requestLoading = false
        this.$showError('Thiếu thông tin cần thiết')
        return
      }

      // if (this.categoryId === 2014) {
      //   this.link = this.link.split('/').pop()
      //   this.link = '/devices-utilities/training-devices/' + this.link
      // } else if (this.categoryId === 2015) {
      //   this.link = this.link.split('/').pop()
      //   this.link = '/devices-utilities/classroom/' + this.link
      // }

      const updatedMedia = {
        id: this.id,
        file: this.fileUpload,
        fileName: this.fileName,
        categoryId: this.categoryId,
        fileDescription: this.fileDescription,
        createdAt: this.createdAt,
        updatedAt: this.getCurrentDate(),
        lang: 'all',
        isHidden: this.isHidden,
        link: this.link,
        enFileName: this.enFileName
      }

      try {
        await this.$store.dispatch('media/updateMedia', updatedMedia)
        this.requestLoading = false
        this.$showSuccess('Cập nhật thành công')
        this.cacheBuster = Date.now()
        this.getMediaData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('media/deleteMedia', id)
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
        this.currentPage--
      }
      this.requestLoading = false
      this.toggleAlert()
      this.getMediaData()
    }
  },
  async mounted () {
    await this.getMediaData()
  }
}

</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  .table-header select {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  /* sua */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  /* Sua */
  td img {
    max-height: 60px;
    max-width: 60px;
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  td video {
    max-height: 60px;
    max-width: 60px;
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  tr:nth-child(even) {background-color: #ececec }

  td:nth-child(1) {
    width: 80px;
    text-align: center;
  }

  td:nth-child(3) {
    text-align: center;
    width: 150px;
  }

  /* th:nth-child(9), td:nth-child(9) {
    text-align: center;
    width: 120px;
  } */

  th:nth-child(9), td:nth-child(9) {
    text-align: center;
    width: 120px;
  }

  th:nth-child(8), td:nth-child(8), th:nth-child(7), td:nth-child(7), th:nth-child(6), td:nth-child(6) {
    text-align: center;
    width: 120px;
  }

  th:nth-child(5), td:nth-child(5) {
    text-align: center;
    width: 150px;
  }

  .overflow-td {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 20px;/* Sua */
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .data-display .cb-box {
    width: 100px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }

  .data-display #cb {
    height: 12px;
    width: auto;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
    margin-right: 10px;
  }

  .data-display label {
    margin-right: 80px;
  }

  .data-display #special-label {
    margin-right: 66px;
  }

  #items {
    justify-content: space-between;
  }

  .data-display-s {
    display: flex;
    align-items: center;
  }

   .data-display-s select{
    margin-left: 24px;
  }

  .outsite > .data-display {
    display: block;
  }

  textarea {
    height: 55px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px;
  }

  .site-box {
    display: flex;
  }

  .first-site {
    flex: 1;
  }

  .second-site {
    width: 305px;
    padding-left: 45px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .errors {
    font-weight: bold;
    color: red;
  }
</style>
